<template>
  <modal :visible="visible" @on-close="onClose()">
    <template v-slot:body>
      <div class="table-responsive">
        <div class="head-info m-2">
          <h6>{{ order.company }} - {{ order.createdAt }}</h6>
        </div>
        <table
          v-if="products.length"
          class="table table-bordered table-striped"
        >
          <thead>
            <tr>
              <th>
                {{ $t("basket.product") }}
              </th>
              <!-- <th>
                {{ $t("basket.price") }}
              </th>
              <th>
                {{ $t("basket.quantity") }}
              </th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in products" :key="product.id">
              <td>
                {{ product.name }}
                <br />
                <small>{{ product.sku }}</small>
              </td>
              <!-- <td>
                {{ currencyDisplay(product.price) }}
              </td>
              <td>
                {{ parseInt(product.quantity) }}
              </td> -->
              <!-- <td>
              <button
                class="btn btn-dark"
                @click="$emit('on-confirm', order)"
              >
                {{ $t('buttons.reorder') }}
              </button>
            </td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template v-slot:footer>
      <!-- <button class="btn btn-secondary m-1">
        <router-link class="nav-link" to="/products">
          {{ $t("navbar.shoppingCart") }}
        </router-link>
      </button> -->
      <button class="btn btn-dark" @click="$emit('on-confirm', order)">
        {{ $t("buttons.reorder") }}
      </button>
      <button class="btn" @click="onClose()">
        {{ $t("buttons.close") }}
      </button>
    </template>
  </modal>
</template>

<script>
import { currencyMixin } from "../mixins";
import Modal from "./Modal";
export default {
  name: "HistoricOrderModal",
  components: {
    Modal,
  },
  mixins: [currencyMixin],
  props: {
    order: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    visible: Boolean,
  },

  computed: {
    orderInfo() {
      return order;
    },
    products() {
      if (this.order && this.order.products) {
        return this.order.products.map((productObject) => ({
          ...productObject.product[0],
          quantity: productObject.product[0].quantity,
        }));
      } else {
        return [];
      }
    },
  },

  methods: {
    onClose() {
      this.$emit("on-close");
    },
  },
};
</script>
